<template>
  <iVideoTile
    :label="summaryLabel"
    :aria-label="`${summaryLabel}: show everyone in the call`"
    data-test="stage-more-people"
    @click="$emit('click')"
  >
    <iRow
      vertical-align="middle"
      align="center"
      width="fill"
      height="fill"
      gap="small"
    >
      <iAvatarStack :people="people" :max="previewLimit" size="small" />
    </iRow>
  </iVideoTile>
</template>

<script>
const PREVIEW_LIMIT = 3;

export default {
  name: "MoreParticipantsTile",
  props: {
    hiddenCount: {
      type: Number,
      required: true,
    },
    previewItems: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["click"],
  computed: {
    previewLimit() {
      return PREVIEW_LIMIT;
    },
    people() {
      const shown = this.previewItems.map(item => ({
        id: item.id,
        name: item.name || "Participant",
      }));
      const unshown = Math.max(0, this.hiddenCount - shown.length);
      const filler = Array.from({ length: unshown }, (unused, index) => ({
        id: `hidden-${index}`,
        name: "Participant",
      }));

      return [...shown, ...filler];
    },
    summaryLabel() {
      return this.hiddenCount === 1 ? "1 more person" : `${this.hiddenCount} more people`;
    },
  },
};
</script>
